<template>
    <div class="c-es" :style="wrapStyle">
        <div :style="innerStyle">
            <div :style="headerStyle">
                <div :style="eyebrowStyle">{{ agencyName }}</div>
                <h1 :style="h1Style">Record your sales for the period</h1>
                <p :style="leadStyle">
                    Brand:
                    <span :style="brandAccentStyle">{{ brandName }}</span>
                    <span v-if="deal">
                        &nbsp;·&nbsp; Deal:
                        <span :style="dealAccentStyle">{{ deal.name }}</span>
                    </span>
                </p>
            </div>
            <CCard :extra-style="cardStyle">
                <div
                    class="wizard__block-table-wrap table-wrap"
                    v-for="(sow_name, __sow_index) in Object.keys(sales)"
                >
                    <p class="sow-name">SOW: {{ sow_name }}</p>
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="center">Period</th>
                                <th>Service</th>
                                <th>Status</th>
                                <th>Required action</th>
                                <th class="with-tooptip">Invoice number <span class="tooltip-btn" data-message="This is where you can record the internal invoice number associated with the invoice you sent your client for this transaction. Recording your internal invoice ID can help us keep track of which invoice is associated with which transaction">?</span></th>
                                <th>Amount Invoiced</th>
                                <th>Amount Collected</th>
                                <th>Hard cost</th>
                                <th>Eligible amount</th>
                                <th>%</th>
                                <th>Commission owed</th>
                                <th class="explanation">Explanation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(sale, index) in Object.values(sales)[
                                    __sow_index
                                ]"
                            >
                                <template v-if="!sale.is_new_project && !sale.is_new_retainer">
                                    <td class="center">{{ sale.period }}</td>
                                    <td class="overlap" style="min-width: 120px; max-width: 120px;">
                                        {{ sale.service.label || "" }}
                                    </td>
                                    <td class="overlap" style="min-width: 180px; max-width: 180px;">
                                        {{
                                            sale && sale.hasOwnProperty("status") && sale.status.hasOwnProperty("title")
                                                ? sale.status.title
                                                : sale && sale.hasOwnProperty("status") && sale.status.hasOwnProperty("title") ? sale.status.name : ""
                                        }}
                                    </td>
                                    <td style="min-width: 210px; max-width: 210px;">
                                        {{ sale && sale.hasOwnProperty("status") && sale.status.hasOwnProperty("action") ? sale.status.action : ""}}
                                        <div
                                            style="min-width: 100%"
                                            class="form-field checkbox-wrap"
                                        >
                                            <input
                                                type="checkbox"
                                                :id="`no_service_provided_${sale.hasOwnProperty('id') ? sale.id : sale.sale.id}`"
                                                :name="`no_service_provided_${sale.hasOwnProperty('id') ? sale.id : sale.sale.id}`"
                                                :checked="activeNoServiceSelects.some((item) => item === sale.id)"
                                                @change="(e) => onChangeNoServiceCheckbox(e.target.checked, sale.id)"
                                            />
                                            <label :for="`no_service_provided_${sale.hasOwnProperty('id') ? sale.id : sale.sale.id}`"
                                            ><i class="icon icon-checkmark"></i
                                            ></label>
                                            No service provided
                                        </div>
                                        <div
                                            class="form-field form-field--modal form-field--tree"
                                            v-if="activeNoServiceSelects.some((item) => item === sale.id)"
                                        >
                                            <treeselect
                                                :placeholder="'Select a reason...'"
                                                :clearable="false"
                                                :searchable='false'
                                                :id="`reason_${sale.hasOwnProperty('id') ? sale.id : sale.sale.id}`"
                                                :name="`reason_${sale.hasOwnProperty('id') ? sale.id : sale.sale.id}`"
                                                :options="reasons_list"
                                                v-model="sale.cancel_reason_id"
                                                @select="(e, id) => updateInput(e.id, sale.id, 'cancel_reason_id', null, sow_name)"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            v-if="sale.status.id === 1"
                                            class="form-field form-field--text"
                                        >
                                            <input
                                                v-model="sale.invoice_number"
                                                style="
                                                    font-size: 14px;
                                                    width: 95px;
                                                    height: 32px;
                                                    border-radius: 4px;
                                                "
                                                @input="
                                                    (e) =>
                                                        updateInput(
                                                            e.target.value,
                                                            sale.sale.id,
                                                            'invoice_number',
                                                            sale.id
                                                        )
                                                "
                                            />
                                        </div>
                                        <div v-else>
                                            {{ sale.invoice_number }}
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            v-if="sale.status.id === 1"
                                            class="form-field form-field--text"
                                        >
                                            <CurrencyInput
                                                :options="currency_input_setting"
                                                :value="sale.amount"
                                                :change="
                                                    (value, index, _key) =>
                                                        updateInputAmount(
                                                            value,
                                                            sale.id,
                                                            _key,
                                                            null,
                                                            sow_name
                                                        )
                                                "
                                                :key_input="'amount'"
                                                :index="index"
                                            />
                                        </div>
                                        <div v-else>
                                            ${{ numberWithCommas(sale.amount) }}
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            v-if="
                                                sale.status.id === 1 ||
                                                sale.status.id === 5
                                            "
                                            class="form-field form-field--text"
                                        >
                                            <CurrencyInput
                                                :options="currency_input_setting"
                                                :value="sale.collected"
                                                :change="
                                                    (value, index, _key) =>
                                                        updateInputCollected(
                                                            value,
                                                            sale.id,
                                                            _key,
                                                            null,
                                                            sow_name
                                                        )
                                                "
                                                :key_input="'collected'"
                                                :index="index"
                                            />
                                        </div>
                                        <div v-else>
                                            ${{ numberWithCommas(sale.collected) }}
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            v-if="
                                                (sale.deal_line_item.deal
                                                    .commission_type_id === 2 &&
                                                    sale.status.id === 1) ||
                                                sale.status.id === 5
                                            "
                                            class="form-field form-field--text"
                                        >
                                            <CurrencyInput
                                                :options="currency_input_setting"
                                                :value="Number(sale.hard_cost)"
                                                :change="
                                                    (value, index, _key) =>
                                                        updateInputHardCost(
                                                            value,
                                                            sale.id,
                                                            _key,
                                                            null,
                                                            sow_name
                                                        )
                                                "
                                                :key_input="'hard_cost'"
                                                :index="index"
                                            />
                                        </div>
                                        <div v-else>
                                            ${{ numberWithCommas(sale.hard_cost) }}
                                        </div>
                                    </td>
                                    <td>
                                        ${{ sale.eligible_amount }}
                                    </td>
                                    <td>{{ sale.procent }}%</td>
                                    <td>
                                        ${{
                                            sale.commission_owed
                                        }}
                                    </td>
                                    <td class="explanation">
                                        <div class="form-field form-field--text">
                                            <textarea
                                                v-model="sale.explanation"
                                                style="
                                                    height: 75px;
                                                    border-radius: 2px;
                                                "
                                                @input="
                                                    (e) =>
                                                        updateInput(
                                                            e.target.value,
                                                            sale.id,
                                                            'explanation',
                                                            null,
                                                            sow_name,
                                                        )
                                                "
                                            ></textarea>
                                        </div>
                                    </td>
                                </template>
                                <template v-else>
                                    <td>{{ sale.period }}</td>
                                    <td class="overlap" style="min-width: 120px; max-width: 120px;">{{ sale.service.label || "" }}</td>
                                    <td class="overlap" style="min-width: 180px; max-width: 180px">
                                        {{
                                            sale && sale.hasOwnProperty("status") && sale.status.hasOwnProperty("title")
                                                ? sale.status.title
                                                : sale && sale.hasOwnProperty("status") && sale.status.hasOwnProperty("title") ? sale.status.name : ""
                                        }}
                                    </td>
                                    <td class="overlap" style="min-width: 210px;  max-width: 210px">
                                        {{ sale && sale.hasOwnProperty("status") && sale.status.hasOwnProperty("action") ? sale.status.action : ""}}
                                    </td>
                                    <td>
                                        <div class="form-field form-field--text">
                                            <input
                                            v-model="sale.invoice_number"
                                            style="
                                                font-size: 14px;
                                                width: 95px;
                                                height: 32px;
                                                border-radius: 4px;
                                            "
                                            @input="
                                                (e) =>
                                                updateProjectInput(
                                                        e.target.value,
                                                        sale.deal_line_item.id,
                                                        'invoice_number',
                                                        sale.is_new_retainer
                                                    )
                                            "
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-field form-field--text">
                                            <CurrencyInput
                                            :options="currency_input_setting"
                                            :value="sale.amount === 0 ? null : sale.amount"
                                            :change="
                                                (value, index, _key) =>
                                                updateProjectInputAmount(
                                                        value,
                                                        sale.deal_line_item.id,
                                                        _key,
                                                        sale.is_new_retainer,
                                                        sow_name
                                                    )
                                            "
                                            :key_input="'amount'"
                                            :index="index"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-field form-field--text">
                                            <CurrencyInput
                                                :options="currency_input_setting"
                                                :value="sale.collected === 0 ? null : sale.collected"
                                                :change="
                                                    (value, index, _key) =>
                                                        updateProjectInputCollected(
                                                            value,
                                                            sale.deal_line_item.id,
                                                            _key,
                                                            sale.is_new_retainer,
                                                            sow_name
                                                        )
                                                "
                                                :key_input="'collected'"
                                                :index="index"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-field form-field--text">
                                            <CurrencyInput
                                                :options="currency_input_setting"
                                                :value="sale.hard_cost === 0 ? null : Number(sale.hard_cost) "
                                                :change="
                                                    (value, index, _key) =>
                                                    updateProjectInputHardcost(
                                                            value,
                                                            sale.deal_line_item.id,
                                                            _key,
                                                            sale.is_new_retainer,
                                                            sow_name
                                                        )
                                                "
                                                :key_input="'hard_cost'"
                                                :index="index"
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        ${{
                                            sale.eligible_amount
                                        }}
                                    </td>
                                    <td>{{ sale.procent }}%</td>
                                    <td>
                                        ${{
                                            sale.commission_owed
                                        }}
                                    </td>
                                    <td class="explanation">
                                        <div class="form-field form-field--text">
                                            <textarea
                                                v-model="sale.explanation"
                                                style="
                                                    height: 75px;
                                                    border-radius: 2px;
                                                "
                                                @input="
                                                    (e) =>
                                                        updateProjectInput(
                                                            e.target.value,
                                                            sale.deal_line_item.id,
                                                            'explanation',
                                                            sale.is_new_retainer
                                                        )
                                                "
                                            ></textarea>
                                        </div>
                                    </td>
                                </template>
                            </tr>
                        </tbody>
                    </table>
                </div>

            <div class="wizard__block-table" style="margin-top: 24px;">
                <div class="wizard__block-table-filter">
                    <div class="row">
                        <div class="col-lg-3 col-md-3">
                            <div class="select">
                                <div class="form-field form-field--tree">
                                    <label>Period</label>
                                    <treeselect
                                        v-model="filter.period"
                                        id="period"
                                        name="period"
                                        :multiple="false"
                                        :options="period_list"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="checkbox"></div>
                </div>
                <div class="wizard__block-table-wrap table-wrap">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Deal</th>
                                <th>Period</th>
                                <th>Status</th>
                                <th>Amount Invoiced</th>
                                <th>Amount Collected</th>
                                <th>%</th>
                                <th>Hard cost</th>
                                <th>Commission owed</th>
                                <th>Service</th>
                                <th>Type</th>
                                <th>Pmt #</th>
                                <th>Notes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="completed_sales.length <= 0">
                                <td colspan="12" class="center">
                                    No historical data
                                </td>
                            </tr>
                            <tr v-else v-for="sale in completed_sales">
                                <td>{{ sale.deal_line_item.deal.name }}</td>
                                <td>{{ sale.period }}</td>
                                <td>
                                    {{
                                        sale.status.title
                                            ? sale.status.title
                                            : sale.status.name
                                    }}
                                </td>
                                <td>${{ numberWithCommas(sale.amount) }}</td>
                                <td>${{ numberWithCommas(sale.collected) }}</td>
                                <td>{{ sale.procent }}%</td>
                                <td>${{ numberWithCommas(sale.hard_cost) }}</td>
                                <td>
                                    ${{
                                        numberWithCommas(sale.commission_owed)
                                    }}
                                </td>
                                <td>
                                    {{ sale.service.label || "" }}
                                </td>
                                <td>{{ sale.type || "" }}</td>
                                <td>{{ sale.pmt || "" }}</td>
                                <td>{{ sale.notes || "" }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            </CCard>

            <div :style="navStyle">
                <CBtn
                    ghost
                    :disabled="!isInitPage || isLoading"
                    @click="onPrevPage"
                >
                    ← Back
                </CBtn>
                <span :style="navHintStyle">autosaved as you go</span>
                <CBtn
                    primary
                    big
                    :disabled="!isInitPage || isLoading"
                    @click="onNextPage"
                >
                    Next →
                </CBtn>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import CurrencyInput from "../components/CurrencyInput";
import ClipLoader from "vue-spinner/src/ClipLoader";

import { SECTIONS } from "../consts";
import axios from "axios";
import _ from "lodash";
import { reInitAllTooltips } from "../../../helpers/_tooltip";

import CCard from "../c-design/CCard.vue";
import CBtn from "../c-design/CBtn.vue";
import viewportMixin from "../c-design/useViewport";
import {
    C_BG,
    C_INK,
    C_INK2,
    C_MUTED,
    C_HAIR,
    C_RED,
    FONT_DISPLAY,
} from "../c-design/tokens";

export default {
    name: "Edit_Sales",
    mixins: [viewportMixin],
    components: {
        Treeselect,
        CurrencyInput,
        ClipLoader,
        CCard,
        CBtn,
    },
    mounted() {
        // Legacy hook that widened the (now-hidden) .wizard__header.
        // Guarded against null since isCDesignSection now removes that
        // element on this section.
        const legacyHeader = document.querySelector(".wizard__header");
        if (legacyHeader) {
            legacyHeader.classList.add("full-width");
        }
        this.getData();
    },
    computed: {
        prevSection() {
            return this.$store.getters.getPrevComponent;
        },

        salesPages() {
            return this.$store.getters.getSalesPages(
                this.$store.getters.getSalesPagesIndex
            );
        },

        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        editDealId() {
            return this.$store.getters.getEditDealId;
        },
        brandName() {
            return this.$store.getters.getCurrentBrandName;
        },
        // ===== c-design style maps =====
        wrapStyle() {
            return {
                background: C_BG,
                minHeight: '70vh',
                padding: this.isMobile ? '14px 12px 28px' : '24px 16px 40px',
            };
        },
        innerStyle() {
            return { maxWidth: '1280px', margin: '0 auto' };
        },
        headerStyle() {
            return {
                marginBottom: this.isMobile ? '16px' : '24px',
                padding: this.isMobile ? '0 4px' : '0 8px',
            };
        },
        eyebrowStyle() {
            return {
                fontSize: '12px', color: C_MUTED, letterSpacing: '0.6px',
                textTransform: 'uppercase', fontWeight: 600,
            };
        },
        h1Style() {
            return {
                margin: '6px 0 8px', fontFamily: FONT_DISPLAY,
                fontSize: this.isMobile ? '24px' : '34px',
                fontWeight: 700,
                letterSpacing: this.isMobile ? '-0.7px' : '-1px',
                lineHeight: 1.1, color: C_INK,
            };
        },
        leadStyle() {
            return { margin: 0, fontSize: '15px', color: C_INK2, lineHeight: 1.55 };
        },
        brandAccentStyle() { return { color: C_RED, fontWeight: 600 }; },
        dealAccentStyle() { return { color: C_INK, fontWeight: 600 }; },
        cardStyle() {
            return { marginBottom: '18px', padding: '24px 28px' };
        },
        navStyle() {
            return {
                marginTop: '8px', padding: '16px 24px',
                background: '#fff', borderRadius: '16px',
                border: `1px solid ${C_HAIR}`,
                display: 'flex', alignItems: 'center',
                justifyContent: 'space-between', gap: '16px',
            };
        },
        navHintStyle() {
            return { fontSize: '12px', color: C_MUTED, fontStyle: 'italic' };
        },
    },
    unmounted() {
        // Symmetric guard to the mounted() side-effect above — the
        // .wizard__header element doesn't exist when this section runs
        // through isCDesignSection.
        const legacyHeader = document.querySelector(".wizard__header");
        if (legacyHeader) {
            legacyHeader.classList.remove("full-width");
        }
    },
    props: ["onChangeSection"],
    data() {
        return {
            SECTIONS,
            currency_input_setting: {
                currency: "USD",
                hideCurrencySymbolOnFocus: false,
                hideGroupingSeparatorOnFocus: false,
                hideNegligibleDecimalDigitsOnFocus: false,
            },
            period_list: [
                {
                    id: 1,
                    label: "10/23",
                },
                {
                    id: 2,
                    label: "11/23",
                },
            ],
            deal: null,
            sales: [],
            dublicate_sales: [],
            completed_sales: [],
            filter: {
                period: null,
                status: [],
            },
            validation_rules: {}, // Init in mounted
            pages: {
                data: null,
                index: 0,
            },
            isInitPage: false,
            isLoading: false,
            activeNoServiceSelects: [],
            reasons_list: [
                {
                    id: 1,
                    label: "Delayed billing"
                },
                {
                    id: 2,
                    label: "Client canceled service"
                },
                {
                    id: 3,
                    label: "New billing type"
                }
            ]
        };
    },
    methods: {
        onChangeStatusCheckbox(e) {
            if (e.target.checked) {
                this.filter.status.push(e.target.value);
            } else {
                this.filter.status = this.filters.status.filter(
                    (i) => i != e.target.value
                );
            }
        },
        onChangeStatusAll(e) {
            if (e.target.checked) {
                this.filter.status = [];
                this.statuses.forEach((filter) => {
                    const _checkbox =
                        this.$refs[`filter_status_${filter.id}`][0];
                    if (_checkbox.checked) {
                        _checkbox.checked = false;
                        _checkbox.dataset.checked = false;
                    }
                });
            }
        },
        numberWithCommas(x) {
            if (!x) {
                return "0";
            }

            let fixednumber = Number(x).toFixed(2);
            let parts = fixednumber.split(".");

            let integerPart = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

            let formattedNumber = integerPart + "." + parts[1];

            return formattedNumber;
        },

        async getData(is_update = false, sale_id = null, sow_name = null, is_retainer = false) {
            this.isLoading = true;

            await axios
                .post("/api/wizard/getList", {
                    page: "sales",
                })
                .then((res) => {
                    let sales_pages_index =
                        this.$store.getters.getSalesPagesIndex;

                    // If click EDIT from confirm
                    if (this.$store.getters.getEditDealId) {
                        res.data.page.forEach((p, index) => {
                            if (
                                p.deal.id ===
                                Number(this.$store.getters.getEditDealId)
                            ) {
                                sales_pages_index = index;
                            }
                        });
                    }

                    if (!res.data.page || res.data.page.length <= 0) {
                        this.onChangeSection(SECTIONS.INVOICES);
                        return;
                    }

                    this.deal = res.data.page[sales_pages_index].deal;
                    this.reasons_list = res.data.page[sales_pages_index].cancel_reasons;

                    if(is_update) {

                        let sale_index = res.data.page[sales_pages_index].sales[sow_name].findIndex((item) => item.id === sale_id);
                        if(is_retainer) sale_index = res.data.page[sales_pages_index].sales[sow_name].findIndex((item) => item.deal_line_item.id === sale_id && !item.sale);
                        this.sales[sow_name][sale_index].commission_owed = res.data.page[sales_pages_index].sales[sow_name][sale_index].commission_owed;
                        this.sales[sow_name][sale_index].procent = res.data.page[sales_pages_index].sales[sow_name][sale_index].procent;
                        this.sales[sow_name][sale_index].eligible_amount = res.data.page[sales_pages_index].sales[sow_name][sale_index].eligible_amount;

                    } else {
                        this.sales = res.data.page[sales_pages_index].sales;
                    }

                    let dataArray = [];

                    for (const key in this.sales) {
                        if (this.sales.hasOwnProperty(key)) {
                            const arrayItems = this.sales[key];
                            arrayItems.forEach((item) => {
                                dataArray.push(item);
                            });
                        }
                    }

                    this.dublicate_sales = dataArray;
                    this.completed_sales =
                        res.data.page[sales_pages_index].history;

                    this.$store.commit("setSalesPages", res.data.page);

                    this.$store.commit(
                        "setCurrentBrandName",
                        res.data.page[sales_pages_index].brand.name
                    );
                })
                .catch((err) => console.log("err getData", err))
                .finally(() => setTimeout(() => {
                    if(!is_update) {
                        this.initValidation()
                    } else {
                        this.isLoading = false;
                    }
                }, 1000));
        },

        updateDataByField(key, value, id = 1, sale_line_item_id = null, sow_name = null, is_new_project = false) {
            debugger
            axios
                .post("api/wizard/updateDraft", {
                    action: is_new_project ? "" : sale_line_item_id ? "updateSale" : "updateSaleLineItem",
                    data: {
                        key,
                        value,
                        id,
                    },
                })
                .then((res) => {
                    //this.$toast.success(res.data.message);
                    this.updateValidationField(
                        id,
                        key,
                        value,
                        sale_line_item_id
                    );

                    if(key !== "explanation") {
                        this.getData(true, id, sow_name);
                    }

                    this.isLoading = false;
                })
                .catch((err) => console.log("Err updateDataByField", err));
        },

        updateInput: _.debounce(function (
            value,
            _id,
            key,
            sale_line_item_id = null,
            sow_name = null,
            is_new_project = false,
            ) {
            if (this.isInitPage) {
                this.isLoading = true;
                this.updateDataByField(key, value, _id, sale_line_item_id, sow_name, is_new_project);
            }
        },
        1000),

        updateInputAmount: _.debounce(function(value,
            _id,
            key,
            sale_line_item_id = null,
            sow_name = null,
            is_new_project = false) {this.updateInputFunction(value, _id, key, sale_line_item_id, sow_name, is_new_project)},1000),

        updateInputCollected: _.debounce(function(value,
            _id,
            key,
            sale_line_item_id = null,
            sow_name = null,
            is_new_project = false) { this.updateInputFunction(value, _id, key, sale_line_item_id, sow_name, is_new_project)},1000),

        updateInputHardCost: _.debounce(function(value,
            _id,
            key,
            sale_line_item_id = null,
            sow_name = null,
            is_new_project = false) { this.updateInputFunction(value, _id, key, sale_line_item_id, sow_name, is_new_project)},1000),

        updateInputFunction(
            value,
            _id,
            key,
            sale_line_item_id = null,
            sow_name = null,
            is_new_project = false) {
                if (this.isInitPage) {
                    this.isLoading = true;
                    this.updateDataByField(key, value, _id, sale_line_item_id, sow_name, is_new_project);
                }
        },

        updateProjectInput: _.debounce(function(value, id, key, is_new_retainer, sow_name) {
            this.updateProjectInputFunction(value, id, key, is_new_retainer, sow_name);
        }, 1000),

        updateProjectInputAmount: _.debounce(function(value, id, key, is_new_retainer, sow_name) {
            this.updateProjectInputFunction(value, id, key, is_new_retainer, sow_name);
        }, 1000),

        updateProjectInputCollected: _.debounce(function(value, id, key, is_new_retainer, sow_name) {
            this.updateProjectInputFunction(value, id, key, is_new_retainer, sow_name);
        }, 1000),

        updateProjectInputHardcost: _.debounce(function(value, id, key, is_new_retainer, sow_name) {
            this.updateProjectInputFunction(value, id, key, is_new_retainer, sow_name);
        }, 1000),

        updateProjectInputFunction(value, id, key, is_new_retainer, sow_name) {
            if(this.isInitPage) {
                axios
                    .post("api/wizard/updateDraft", {
                        action: "createProjectSale",
                        data: {
                            key,
                            value,
                            id,
                        },
                    })
                    .then((res) => {


                        if(is_new_retainer) {
                            this.updateValidationField(
                                `${id}_retainer`,
                                key,
                                value
                            );
                        }

                        if(key !== "explanation") {
                            this.getData(true, id, sow_name, true);
                        }

                    })
                    .catch((err) => console.log("Err updateProjectInputFunction", err))

            }
        },

        initValidation() {
            if (true) {
                let __object_rules = {};

                // let dataArray = Object.keys(this.sales).map((key, index) => ({
                //     ...this.sales[key],
                // }));

                // if (
                //     typeof this.sales === "object" &&
                //     !Array.isArray(this.sales)
                // ) {
                //     dataArray = Object.keys(this.sales).map((key, index) => ({
                //         ...this.sales[key],
                //     }));
                // } else {
                //     dataArray = Object.values(this.sales);
                // }

                let dataArray = [];

                for (const key in this.sales) {
                    if (this.sales.hasOwnProperty(key)) {
                        const arrayItems = this.sales[key];
                        arrayItems.forEach((item) => {
                            dataArray.push(item);
                        });
                    }
                }

                dataArray.forEach((sale) => {

                    if(sale.is_new_project) {
                        return;
                    }

                    if(sale.cancel_reason_id) {
                        this.activeNoServiceSelects.push(sale.id);
                    }

                    if(sale.is_new_retainer) {
                        return (__object_rules[`${sale.deal_line_item.id}_retainer`] = {
                            amount: {
                                required: sale.status.id === 1,
                                value: sale.amount || undefined,
                            },
                            collected: {
                                required:
                                    sale.status.id === 1 || sale.status.id === 5,
                                value: sale.collected || undefined,
                            },
                            hard_cost: {
                                required: false,
                                value: sale.hard_cost || undefined,
                            },
                            explanation: {
                                value: sale.explanation,
                            },
                            invoice_number: {
                                value: sale.invoice_number,
                            },
                            no_service: {
                                required: !!sale.cancel_reason_id,
                                value: sale.cancel_reason_id ? sale.cancel_reason_id : null,
                            }
                        })
                    }

                    return (__object_rules[sale.id] = {
                        amount: {
                            required: sale.status.id === 1,
                            value: sale.amount || undefined,
                        },
                        collected: {
                            required:
                                sale.status.id === 1 || sale.status.id === 5,
                            value: sale.collected || undefined,
                        },
                        hard_cost: {
                            required: false,
                            value: sale.hard_cost || undefined,
                        },
                        explanation: {
                            value: sale.explanation,
                        },
                        invoice_number: {
                            value: sale.invoice_number,
                        },
                        no_service: {
                            required: !!sale.cancel_reason_id,
                            value: sale.cancel_reason_id ? sale.cancel_reason_id : null,
                        }
                    });
                });

                this.validation_rules = __object_rules;

                console.table(__object_rules)

                setTimeout(() => {
                    this.isInitPage = true;
                    this.isLoading = false;
                }, 1000);

                setTimeout(() => {
                    reInitAllTooltips();
                }, 750)


            }
        },

        updateValidationField(sale_id, key, value, sale_line_item_id) {

            if (sale_line_item_id) {

                if(key === 'no_service_required') {
                    this.validation_rules[sale_line_item_id]['no_service'].required = value;
                    return
                }

                if(key === 'cancel_reason_id') {
                    this.validation_rules[sale_line_item_id]['no_service'].value = value;
                    return
                }

                this.validation_rules[sale_line_item_id][key].value = value;
            } else {

                if(key === 'no_service_required') {
                    this.validation_rules[sale_id]['no_service'].required = value;
                    return
                }

                if(key === 'cancel_reason_id') {
                    this.validation_rules[sale_id]['no_service'].value = value;
                    return
                }

                this.validation_rules[`${sale_id}`][key].value = value;
            }
        },

        checkValidation() {

            if (true) {
                let isValidate = true;
                let isHasReason = true;

                let dataArray = [];

                for (const key in this.sales) {
                    if (this.sales.hasOwnProperty(key)) {
                        const arrayItems = this.sales[key];
                        arrayItems.forEach((item) => {
                            dataArray.push(item);
                        });
                    }
                }

                dataArray.forEach((sale) => {

                    if(sale.is_new_project) {
                        return;
                    }

                    let _id = sale.id;

                    if(sale.is_new_retainer) {
                        _id = `${sale.deal_line_item.id}_retainer`;
                    }

                    const sale_rules = this.validation_rules[`${_id}`];

                    if(this.activeNoServiceSelects.some((item) => item === _id) && sale_rules.no_service.value) {
                        return
                    }

                    if(this.activeNoServiceSelects.some((item) => item === _id) && !sale_rules.no_service.value) {

                        isHasReason = false;

                        return
                    }

                    if(sale_rules.explanation.value) {
                        return
                    }
                    else if (
                        sale_rules.amount.required &&
                        (!sale_rules.amount.value || Number(sale_rules.amount.value) <= 0)
                    ) {
                        /*console.table({
                            id: _id,
                            amount: sale_rules.amount.value,
                            required: sale_rules.amount.required
                        })*/
                        isValidate = false;
                        console.log("sale_rules.amount.required && !sale_rules.amount.value && Number(sale_rules.amount.value) <= 0", _id)
                        console.log(sale_rules.amount)
                    } else if (
                        sale_rules.collected.required &&
                        !sale_rules.collected.value
                    ) {
                        isValidate = false;
                        console.log("sale_rules.collected.required && !sale_rules.collected.value", _id)
                        console.log(sale_rules.collected)
                    } else if (
                        sale_rules.hard_cost.required &&
                        !sale_rules.hard_cost.value &&
                        sale_rules.hard_cost.value != 0
                    ) {
                        isValidate = false;
                        console.log("sale_rules.hard_cost.required && !sale_rules.hard_cost.value && sale_rules.hard_cost.value != 0", _id)
                        console.log(sale_rules.hard_cost)
                    }


                });

                if(!isHasReason) {
                    // console.log("Enter")
                    this.$toast.error(`You should choose "reason" for “no service provided” item`);
                }

                if(!isValidate) {
                    this.$toast.error(
                        "You should fill in the amounts for each row of the table or write an explanation"
                    );
                }

                return (isValidate && isHasReason);
            }
        },

        onPrevPage() {
            this.$store.commit(
                "setSalesPagesIndex",
                0
            );
            this.onChangeSection(SECTIONS.DASHBOARD, null)
        },

        onNextPage() {
            let isValidate = this.checkValidation();

            if (isValidate) {
                if (this.editDealId) {
                    this.onChangeSection(SECTIONS.FINAL_DASHBOARD);
                    return;
                }

                this.onChangeSection(SECTIONS.DO_YOU_HAVE_UPSELL);

                // if (this.pages.data.length === this.pages.index + 1) {

                //     return;
                // }

                // this.deal = this.pages.data[this.pages.index + 1].deal;
                // this.sales = this.pages.data[this.pages.index + 1].sales;
                // this.dublicate_sales =
                //     this.pages.data[this.pages.index + 1].sales;
                // this.completed_sales =
                //     this.pages.data[this.pages.index + 1].history;

                // this.pages.index = this.pages.index + 1;

                // this.initValidation();

                // window.scrollTo({ top: 0, behavior: "smooth" });
            }
        },

        onChangeNoServiceCheckbox(is_checked, __sale_id) {
            if(__sale_id) {
                if(is_checked) {
                    this.activeNoServiceSelects.push(__sale_id)
                } else {
                    this.activeNoServiceSelects = this.activeNoServiceSelects.filter((item) => item !== __sale_id)
                    axios
                        .post("api/wizard/updateDraft", {
                            action: "updateSaleLineItem",
                            data: {
                                key: 'cancel_reason_id',
                                value: null,
                                id: __sale_id,
                            },
                        })
                        .catch((err) => console.log("Err onChangeNoServiceCheckbox", err));
                }
            }
        }
    },
};
</script>
